export const isMobileApp = () =>
  typeof window !== 'undefined' &&
  window.navigator?.userAgent?.includes('cinchapp')
